/* eslint-disable */
YP.NewsletterManager = function() {
    var campaignForm = $('.js-form-init-campaign');

    return {
        init: function() {
            $('.js-choice-type-campaign').live('change', {
                klass: this
            }, this.refreshCampaignForm);
            $('.js-choice-event').live('change', {
                klass: this
            }, this.refreshCampaignForm);

            if($('.js-form_campaign_ticket_promotion').length) {
                YP.EventPromotionsManager().initFormCampaign();
            }
        },
        refreshCampaignForm: function(e) {
            e.preventDefault();
            $('.js-form-init-campaign button').prop('disabled', true);

            klass        = e.data.klass;
            title        = $('.js-campaign-title').val();
            eventId      = $('.js-choice-event').val();
            campaignType = $('.js-choice-type-campaign').val();

            $.ajax({
                url: campaignForm.data('href'),
                type: 'GET',
                dataType: 'json',
                data: {
                    'title'        : title,
                    'eventId'      : eventId,
                    'campaignType' : campaignType
                },
                success: function(data) {
                    $('.js-form-init-campaign button').removeAttr('disabled');
                    campaignForm.find('fieldset').html(data.view);
                    if(campaignType == 4) {
                        YP.EventPromotionsManager().initFormCampaign();
                    }
                }
            });
        },
    }
};
window.addEventListener("load", function() {
    YP.NewsletterManager().init();
});
